import Image from "next/image"

interface ImpactfulStatementWarningProps {
  hasImpactfulStatements?: boolean;
}

export const ImpactfulStatementWarning: React.FC<ImpactfulStatementWarningProps> = ({ 
  hasImpactfulStatements = false 
}) => {
  return (
    <div className="flex mt-4 md:mt-3 flex-col gap-4 rounded-xl p-4 lg:p-6 bg-[#F6F6F6] relative">
      {/* Half-in Half-out Heading */}
      <div className="absolute top-[-16px] left-4 lg:left-8 bg-white text-black px-4 lg:px-6 py-2 rounded-xl shadow-md flex items-center gap-2">
        <Image
          src="/icons/score-check/Announcement.svg"
          width={20}
          height={20}
          alt="icon"
          className="h-4 w-4 lg:h-5 lg:w-5"
        />
        <span className="text-sm lg:text-base xl:text-lg font-bold">
          {hasImpactfulStatements ? "Impactful" : "Low Impact"}
        </span>
      </div>

      <div className="flex flex-col items-center justify-center gap-3 mt-6">
        <div className="relative w-32 h-32 lg:w-40 lg:h-40">
          <Image 
            src={hasImpactfulStatements 
              ? "/assets/resumeScore/Impactful.png" 
              : "/assets/resumeScore/lowImpact.png"}
            alt={hasImpactfulStatements ? "Impactful statements found" : "No impactful statements"}
            fill
            className="object-contain"
          />
        </div>
        
        {hasImpactfulStatements ? (
          <>
            <p className="text-center text-sm lg:text-base text-green-600 font-semibold">
              Impactful statements found
            </p>
            <p className="text-center text-xs lg:text-sm text-gray-600 px-4">
              clearly highlight your achievements and add strength to your resume.
            </p>
          </>
        ) : (
          <>
            <p className="text-center text-sm lg:text-base text-red-600 font-semibold">
              Statements are not impactful
            </p>
            <p className="text-center text-xs lg:text-sm text-gray-600 px-4">
              Use action words, show results, and keep it clear — impact comes from what you achieved, not how much you write.
            </p>
          </>
        )}
      </div>
    </div>
  );
}